import { useEffect } from "react";
import { Card, Divider, Text, VerticalStack, Box } from "@shopify/polaris";

import { GettingStartedStoreAccess } from "../../libs/store";

import ConnectStore from "../ConnectStore";
import SubscriptionProgramSetup from "../SubscriptionProgramSetup";
import InstallPortal from "../InstallPortal";
import { SubscriptionBlock } from "../SubscriptionBlock";
import MigrationService from "../MigrationService";

export function SetupChecklist() {
  const { initialize } = GettingStartedStoreAccess.useActions();

  useEffect(() => {
    void initialize();
  }, []);

  return (
    <Card padding="0">
      <VerticalStack gap="0">
        <Box padding="4">
          <Text variant="headingMd" as="h2">
            Setup Checklist
          </Text>
        </Box>

        <Divider />

        <Box padding="4">
          <ConnectStore />
        </Box>

        <Divider />

        <Box padding="4">
          <MigrationService />
        </Box>

        <Divider />

        <Box padding="4">
          <SubscriptionProgramSetup />
        </Box>

        <Divider />

        <Box padding="4">
          <SubscriptionBlock />
        </Box>

        <Divider />

        <Box padding="4">
          <InstallPortal />
        </Box>
      </VerticalStack>
    </Card>
  );
}
